<template>
    <avue-crud
            :option="option"
            :data="data"
            :page="page"
            @refresh-change="refreshChange"
            @search-change="searchChange"
            @row-save="store"
            @row-update="update"
            @row-del="del"
            @size-change="sizeChange"
            @current-change="currentChange"
            :upload-before="uploadBefore"
            ref="crud"
    >
    </avue-crud>
</template>
<script>
  import curd from './Base/Crud'

  export default {
    mixins: [curd],
    data() {
      return {
        // curd组件
        option: {
          viewBtn: true, // 查看按钮显隐
          addBtn: false, // 增加按钮显隐
          addBtnText: '新增', // 新增按钮文案
          editBtn: true, // 修改按钮显隐
          delBtn: false, // 删除按钮显隐
          columnBtn: false, // 列显隐按钮
          headerAlign: 'center', // 表头居中
          align: 'center', // 表内容 居中
          searchMenuSpan: 5, // 搜索同行 搜索所占宽度
          index: true, // 行首 索引
          dialogClickModal: false, // 是否可以通过点击modal关闭Dialog
          column: [
            {
              label: '功能名称',
              prop: 'title',
              // display: false,
              span: 24,
              rules: [{
                type: 'string', required: true, message: '邮箱名称不能为空', trigger: 'blur'
              }]
            },
            {
              label: '备注描述',
              overHidden: true,
              prop: 'desc',
              // display: false,
              span: 24,
              align: 'left'
            },
            {
              label: '邮箱地址',
              overHidden: true,
              prop: 'url',
              span: 24,
              rules: [{
                required: true, message: '邮箱地址不能为空', trigger: 'blur'
              }],
              type: 'select',
              allowCreate: true, // 允许添加条目
              filterable: true, // 级联框是否可以搜索
              multiple: true, // 多选
              defaultFirstOption: true, // 回车选中
              dicDate: [],
              placeholder: '回车创建条目'
            },
            {
              label: '邮件内容',
              prop: 'content',
              overHidden: true,
              type: 'textarea',
              span: 24,
              rules: [{
                required: true, message: '内容不能为空', trigger: 'blur'
              }]
            }
          ]
        }
      }
    }
  }
</script>
